var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-container",
    {
      attrs: {
        fluid: ""
      }
    },
    [
      _c(
        "gg-card",
        [
          _c("gg-card-header", [_vm._v(" What to Expect ")]),
          _c(
            "gg-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("v-sheet", [
                        _vm._v(
                          " If you rather setup the account later manually, you can do so by skipping the Quick Launch Wizard. You can always re-launch this wizard by going to Hosting > " +
                            _vm._s(_vm.serviceDomain) +
                            " > and clicking the Manage button. "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        {
          staticClass: "pt-3"
        },
        [
          _c(
            "v-col",
            {
              staticClass: "text-center",
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-btn",
                {
                  staticClass: "ml-2",
                  attrs: {
                    tile: "",
                    color: "primary",
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.exit
                  }
                },
                [_vm._v("Skip & Exit")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }